type Amount = { amount?: number | null } | null;

type PricedItem = {
  type?: string;
  price?: Amount;
  bookable?: { price?: Amount } | null;
  discount?: { standardPrice?: Amount } | null;
};

const originalAmount = (item: PricedItem) =>
  item.bookable?.price?.amount ?? item.discount?.standardPrice?.amount ?? item.price?.amount ?? 0;

export const isNoValueTableBooking = (item: PricedItem | null | undefined): boolean =>
  item?.type === 'tables' && originalAmount(item) === 0;

export const hasOnlyNoValueTableBookings = (items: unknown): boolean => {
  const list = Array.isArray(items) ? (items as PricedItem[]) : [];
  return list.length > 0 && list.every(isNoValueTableBooking);
};
